import { reactive } from 'vue';

// Lista de todos los países del mundo con deleted_at: null
export const countryGroups = [
  { id: 1, name: 'Afganistán', deleted_at: null },
  { id: 2, name: 'Albania', deleted_at: null },
  { id: 3, name: 'Alemania', deleted_at: null },
  { id: 4, name: 'Andorra', deleted_at: null },
  { id: 5, name: 'Angola', deleted_at: null },
  { id: 6, name: 'Antigua y Barbuda', deleted_at: null },
  { id: 7, name: 'Arabia Saudita', deleted_at: null },
  { id: 8, name: 'Argelia', deleted_at: null },
  { id: 9, name: 'Argentina', deleted_at: null },
  { id: 10, name: 'Armenia', deleted_at: null },
  { id: 11, name: 'Australia', deleted_at: null },
  { id: 12, name: 'Austria', deleted_at: null },
  { id: 13, name: 'Azerbaiyán', deleted_at: null },
  { id: 14, name: 'Bahamas', deleted_at: null },
  { id: 15, name: 'Bangladés', deleted_at: null },
  { id: 16, name: 'Barbados', deleted_at: null },
  { id: 17, name: 'Baréin', deleted_at: null },
  { id: 18, name: 'Bélgica', deleted_at: null },
  { id: 19, name: 'Belice', deleted_at: null },
  { id: 20, name: 'Benín', deleted_at: null },
  { id: 21, name: 'Bielorrusia', deleted_at: null },
  { id: 22, name: 'Birmania', deleted_at: null },
  { id: 23, name: 'Bolivia', deleted_at: null },
  { id: 24, name: 'Bosnia y Herzegovina', deleted_at: null },
  { id: 25, name: 'Botsuana', deleted_at: null },
  { id: 26, name: 'Brasil', deleted_at: null },
  { id: 27, name: 'Brunéi', deleted_at: null },
  { id: 28, name: 'Bulgaria', deleted_at: null },
  { id: 29, name: 'Burkina Faso', deleted_at: null },
  { id: 30, name: 'Burundi', deleted_at: null },
  { id: 31, name: 'Bután', deleted_at: null },
  { id: 32, name: 'Cabo Verde', deleted_at: null },
  { id: 33, name: 'Camboya', deleted_at: null },
  { id: 34, name: 'Camerún', deleted_at: null },
  { id: 35, name: 'Canadá', deleted_at: null },
  { id: 36, name: 'Catar', deleted_at: null },
  { id: 37, name: 'Chad', deleted_at: null },
  { id: 38, name: 'Chile', deleted_at: null },
  { id: 39, name: 'China', deleted_at: null },
  { id: 40, name: 'Chipre', deleted_at: null },
  { id: 41, name: 'Ciudad del Vaticano', deleted_at: null },
  { id: 42, name: 'Colombia', deleted_at: null },
  { id: 43, name: 'Comoras', deleted_at: null },
  { id: 44, name: 'Corea del Norte', deleted_at: null },
  { id: 45, name: 'Corea del Sur', deleted_at: null },
  { id: 46, name: 'Costa de Marfil', deleted_at: null },
  { id: 47, name: 'Costa Rica', deleted_at: null },
  { id: 48, name: 'Croacia', deleted_at: null },
  { id: 49, name: 'Cuba', deleted_at: null },
  { id: 50, name: 'Dinamarca', deleted_at: null },
  { id: 51, name: 'Dominica', deleted_at: null },
  { id: 52, name: 'Ecuador', deleted_at: null },
  { id: 53, name: 'Egipto', deleted_at: null },
  { id: 54, name: 'El Salvador', deleted_at: null },
  { id: 55, name: 'Emiratos Árabes Unidos', deleted_at: null },
  { id: 56, name: 'Eritrea', deleted_at: null },
  { id: 57, name: 'Eslovaquia', deleted_at: null },
  { id: 58, name: 'Eslovenia', deleted_at: null },
  { id: 59, name: 'España', deleted_at: null },
  { id: 60, name: 'Estados Unidos', deleted_at: null },
  { id: 61, name: 'Estonia', deleted_at: null },
  { id: 62, name: 'Esuatini', deleted_at: null },
  { id: 63, name: 'Etiopía', deleted_at: null },
  { id: 64, name: 'Filipinas', deleted_at: null },
  { id: 65, name: 'Finlandia', deleted_at: null },
  { id: 66, name: 'Fiyi', deleted_at: null },
  { id: 67, name: 'Francia', deleted_at: null },
  { id: 68, name: 'Gabón', deleted_at: null },
  { id: 69, name: 'Gambia', deleted_at: null },
  { id: 70, name: 'Georgia', deleted_at: null },
  { id: 71, name: 'Ghana', deleted_at: null },
  { id: 72, name: 'Granada', deleted_at: null },
  { id: 73, name: 'Grecia', deleted_at: null },
  { id: 74, name: 'Guatemala', deleted_at: null },
  { id: 75, name: 'Guinea', deleted_at: null },
  { id: 76, name: 'Guinea-Bisáu', deleted_at: null },
  { id: 77, name: 'Guinea Ecuatorial', deleted_at: null },
  { id: 78, name: 'Guyana', deleted_at: null },
  { id: 79, name: 'Haití', deleted_at: null },
  { id: 80, name: 'Honduras', deleted_at: null },
  { id: 81, name: 'Hungría', deleted_at: null },
  { id: 82, name: 'India', deleted_at: null },
  { id: 83, name: 'Indonesia', deleted_at: null },
  { id: 84, name: 'Irak', deleted_at: null },
  { id: 85, name: 'Irán', deleted_at: null },
  { id: 86, name: 'Irlanda', deleted_at: null },
  { id: 87, name: 'Islandia', deleted_at: null },
  { id: 88, name: 'Islas Marshall', deleted_at: null },
  { id: 89, name: 'Islas Salomón', deleted_at: null },
  { id: 90, name: 'Israel', deleted_at: null },
  { id: 91, name: 'Italia', deleted_at: null },
  { id: 92, name: 'Jamaica', deleted_at: null },
  { id: 93, name: 'Japón', deleted_at: null },
  { id: 94, name: 'Jordania', deleted_at: null },
  { id: 95, name: 'Kazajistán', deleted_at: null },
  { id: 96, name: 'Kenia', deleted_at: null },
  { id: 97, name: 'Kirguistán', deleted_at: null },
  { id: 98, name: 'Kiribati', deleted_at: null },
  { id: 99, name: 'Kosovo', deleted_at: null },
  { id: 100, name: 'Kuwait', deleted_at: null },
  { id: 101, name: 'Laos', deleted_at: null },
  { id: 102, name: 'Lesoto', deleted_at: null },
  { id: 103, name: 'Letonia', deleted_at: null },
  { id: 104, name: 'Líbano', deleted_at: null },
  { id: 105, name: 'Liberia', deleted_at: null },
  { id: 106, name: 'Libia', deleted_at: null },
  { id: 107, name: 'Liechtenstein', deleted_at: null },
  { id: 108, name: 'Lituania', deleted_at: null },
  { id: 109, name: 'Luxemburgo', deleted_at: null },
  { id: 110, name: 'Madagascar', deleted_at: null },
  { id: 111, name: 'Malasia', deleted_at: null },
  { id: 112, name: 'Malaui', deleted_at: null },
  { id: 113, name: 'Maldivas', deleted_at: null },
  { id: 114, name: 'Malí', deleted_at: null },
  { id: 115, name: 'Malta', deleted_at: null },
  { id: 116, name: 'Marruecos', deleted_at: null },
  { id: 117, name: 'Mauricio', deleted_at: null },
  { id: 118, name: 'Mauritania', deleted_at: null },
  { id: 119, name: 'México', deleted_at: null },
  { id: 120, name: 'Micronesia', deleted_at: null },
  { id: 121, name: 'Moldavia', deleted_at: null },
  { id: 122, name: 'Mónaco', deleted_at: null },
  { id: 123, name: 'Mongolia', deleted_at: null },
  { id: 124, name: 'Montenegro', deleted_at: null },
  { id: 125, name: 'Mozambique', deleted_at: null },
  { id: 126, name: 'Namibia', deleted_at: null },
  { id: 127, name: 'Nauru', deleted_at: null },
  { id: 128, name: 'Nepal', deleted_at: null },
  { id: 129, name: 'Nicaragua', deleted_at: null },
  { id: 130, name: 'Níger', deleted_at: null },
  { id: 131, name: 'Nigeria', deleted_at: null },
  { id: 132, name: 'Noruega', deleted_at: null },
  { id: 133, name: 'Nueva Zelanda', deleted_at: null },
  { id: 134, name: 'Omán', deleted_at: null },
  { id: 135, name: 'Países Bajos', deleted_at: null },
  { id: 136, name: 'Pakistán', deleted_at: null },
  { id: 137, name: 'Palaos', deleted_at: null },
  { id: 138, name: 'Panamá', deleted_at: null },
  { id: 139, name: 'Papúa Nueva Guinea', deleted_at: null },
  { id: 140, name: 'Paraguay', deleted_at: null },
  { id: 141, name: 'Perú', deleted_at: null },
  { id: 142, name: 'Polonia', deleted_at: null },
  { id: 143, name: 'Portugal', deleted_at: null },
  { id: 144, name: 'Reino Unido', deleted_at: null },
  { id: 145, name: 'República Centroafricana', deleted_at: null },
  { id: 146, name: 'República Checa', deleted_at: null },
  { id: 147, name: 'República del Congo', deleted_at: null },
  { id: 148, name: 'República Democrática del Congo', deleted_at: null },
  { id: 149, name: 'República Dominicana', deleted_at: null },
  { id: 150, name: 'Ruanda', deleted_at: null },
  { id: 151, name: 'Rumanía', deleted_at: null },
  { id: 152, name: 'Rusia', deleted_at: null },
  { id: 153, name: 'Samoa', deleted_at: null },
  { id: 154, name: 'San Cristóbal y Nieves', deleted_at: null },
  { id: 155, name: 'San Marino', deleted_at: null },
  { id: 156, name: 'San Vicente y las Granadinas', deleted_at: null },
  { id: 157, name: 'Santa Lucía', deleted_at: null },
  { id: 158, name: 'Santo Tomé y Príncipe', deleted_at: null },
  { id: 159, name: 'Senegal', deleted_at: null },
  { id: 160, name: 'Serbia', deleted_at: null },
  { id: 161, name: 'Seychelles', deleted_at: null },
  { id: 162, name: 'Sierra Leona', deleted_at: null },
  { id: 163, name: 'Singapur', deleted_at: null },
  { id: 164, name: 'Siria', deleted_at: null },
  { id: 165, name: 'Somalia', deleted_at: null },
  { id: 166, name: 'Sri Lanka', deleted_at: null },
  { id: 167, name: 'Sudáfrica', deleted_at: null },
  { id: 168, name: 'Sudán', deleted_at: null },
  { id: 169, name: 'Sudán del Sur', deleted_at: null },
  { id: 170, name: 'Suecia', deleted_at: null },
  { id: 171, name: 'Suiza', deleted_at: null },
  { id: 172, name: 'Surinam', deleted_at: null },
  { id: 173, name: 'Tailandia', deleted_at: null },
  { id: 174, name: 'Tanzania', deleted_at: null },
  { id: 175, name: 'Tayikistán', deleted_at: null },
  { id: 176, name: 'Timor Oriental', deleted_at: null },
  { id: 177, name: 'Togo', deleted_at: null },
  { id: 178, name: 'Tonga', deleted_at: null },
  { id: 179, name: 'Trinidad y Tobago', deleted_at: null },
  { id: 180, name: 'Túnez', deleted_at: null },
  { id: 181, name: 'Turkmenistán', deleted_at: null },
  { id: 182, name: 'Turquía', deleted_at: null },
  { id: 183, name: 'Tuvalu', deleted_at: null },
  { id: 184, name: 'Ucrania', deleted_at: null },
  { id: 185, name: 'Uganda', deleted_at: null },
  { id: 186, name: 'Uruguay', deleted_at: null },
  { id: 187, name: 'Uzbekistán', deleted_at: null },
  { id: 188, name: 'Vanuatu', deleted_at: null },
  { id: 189, name: 'Venezuela', deleted_at: null },
  { id: 190, name: 'Vietnam', deleted_at: null },
  { id: 191, name: 'Yemen', deleted_at: null },
  { id: 192, name: 'Yibuti', deleted_at: null },
  { id: 193, name: 'Zambia', deleted_at: null },
  { id: 194, name: 'Zimbabue', deleted_at: null }
]

// Lista de escolaridades con deleted_at: null
export const schoolGroups = [
  { id: 1, name: 'Primaria', deleted_at: null },
  { id: 2, name: 'Secundaria', deleted_at: null },
  { id: 3, name: 'Preparatoria', deleted_at: null },
  { id: 4, name: 'Licenciatura', deleted_at: null },
  { id: 5, name: 'Maestría', deleted_at: null },
  { id: 6, name: 'Doctorado', deleted_at: null },
  { id: 7, name: 'Posdoctorado', deleted_at: null },
  { id: 8, name: 'Sin escolaridad', deleted_at: null }
]

// Lista de estados civiles con deleted_at: null
export const maritalGroups = [
  { id: 1, name: 'Soltero/a', deleted_at: null },
  { id: 2, name: 'Casado/a', deleted_at: null },
  { id: 3, name: 'Divorciado/a', deleted_at: null },
  { id: 4, name: 'Viudo/a', deleted_at: null },
  { id: 5, name: 'Unión Libre', deleted_at: null },
  { id: 6, name: 'Separado/a', deleted_at: null },
  { id: 7, name: 'Comprometido/a', deleted_at: null },
  { id: 8, name: 'Concubinato', deleted_at: null },
  { id: 9, name: 'No aplica', deleted_at: null }
]

// Lista de grupos sanguíneos con deleted_at: null
export const bloodGroups = [
  { id: 1, name: 'A+', deleted_at: null },
  { id: 2, name: 'A-', deleted_at: null },
  { id: 3, name: 'B+', deleted_at: null },
  { id: 4, name: 'B-', deleted_at: null },
  { id: 5, name: 'AB+', deleted_at: null },
  { id: 6, name: 'AB-', deleted_at: null },
  { id: 7, name: 'O+', deleted_at: null },
  { id: 8, name: 'O-', deleted_at: null },
  { id: 9, name: 'Desconoce', deleted_at: null }
]

// Lista de religiones con deleted_at: null
export const religionGroups = [
  { id: 1, name: 'Cristianismo', deleted_at: null }, // Incluye Catolicismo, Protestantismo, Ortodoxia
  { id: 2, name: 'Islam', deleted_at: null },
  { id: 3, name: 'Hinduismo', deleted_at: null },
  { id: 4, name: 'Budismo', deleted_at: null },
  { id: 5, name: 'Sijismo', deleted_at: null },
  { id: 6, name: 'Judaísmo', deleted_at: null },
  { id: 7, name: 'Taoísmo', deleted_at: null },
  { id: 8, name: 'Confucianismo', deleted_at: null },
  { id: 9, name: 'Shintoísmo', deleted_at: null },
  { id: 10, name: 'Ateísmo', deleted_at: null },
  { id: 11, name: 'Agnosticismo', deleted_at: null },
  { id: 12, name: 'Espiritismo', deleted_at: null },
  { id: 13, name: 'Fe Bahá í', deleted_at: null },
  { id: 14, name: 'Zoroastrismo', deleted_at: null },
  { id: 15, name: 'Jainismo', deleted_at: null },
  { id: 16, name: 'Pastafarismo', deleted_at: null },
  { id: 17, name: 'Santería', deleted_at: null }, // Muy popular en Cuba y otras regiones del Caribe
  { id: 18, name: 'Candomblé', deleted_at: null }, // Popular en Brasil
  { id: 19, name: 'Umbanda', deleted_at: null }, // Practicada principalmente en Brasil
  { id: 20, name: 'Palo Mayombe', deleted_at: null }, // Religión afrocubana
  { id: 21, name: 'Vudú', deleted_at: null }, // Practicado en Haití y partes de América Latina
  { id: 22, name: 'Catolicismo Popular', deleted_at: null }, // Con prácticas sincréticas de América Latina
  { id: 23, name: 'Otra', deleted_at: null } // Otras creencias o religiones no mencionadas
]

// Lista de métodos de planificación familiar con deleted_at: null
export const familyPlanningMethods = [
  { id: 1, name: 'Método del Ritmo', deleted_at: null },
  { id: 2, name: 'Método de la Temperatura Basal', deleted_at: null },
  { id: 3, name: 'Método del Moco Cervical', deleted_at: null },
  { id: 4, name: 'Método de Lactancia y Amenorrea (MELA)', deleted_at: null },
  { id: 5, name: 'Píldoras Anticonceptivas', deleted_at: null },
  { id: 6, name: 'Inyecciones Anticonceptivas', deleted_at: null },
  { id: 7, name: 'Implantes Subdérmicos', deleted_at: null },
  { id: 8, name: 'Parches Anticonceptivos', deleted_at: null },
  { id: 9, name: 'Anillo Vaginal', deleted_at: null },
  { id: 10, name: 'Condón Masculino', deleted_at: null },
  { id: 11, name: 'Condón Femenino', deleted_at: null },
  { id: 12, name: 'Diafragma', deleted_at: null },
  { id: 13, name: 'Espermicidas', deleted_at: null },
  { id: 14, name: 'DIU de Cobre', deleted_at: null },
  { id: 15, name: 'DIU Hormonal', deleted_at: null },
  { id: 16, name: 'Ligadura de Trompas', deleted_at: null },
  { id: 17, name: 'Vasectomía', deleted_at: null },
  { id: 18, name: 'Píldora de Anticoncepción de Emergencia', deleted_at: null },
  { id: 19, name: 'DIU de Cobre como Método de Emergencia', deleted_at: null },
  { id: 20, name: 'Ninguno', deleted_at: null },
  { id: 21, name: 'Otro', deleted_at: null }
]

export const stateNames = reactive([
  { id: 1, name: "Pendiente" },
  { id: 2, name: "Confirmado" },
  { id: 3, name: "Cancelado" }
]);

export const invoiceType = [
  { id: 'subscription', name: 'Suscripción' },
  { id: 'custom_service', name: 'Servicio personalizado' },
  { id: 'development', name: 'Desarrollo' },
  { id: 'support', name: 'Soporte' },
  { id: 'excess-user', name: 'Usuario adicional' }
];

export const invoiceStatus = [
  { id: 'pending', name: 'Pendiente' },
  { id: 'paid', name: 'Pagada' },
  { id: 'cancelled', name: 'Cancelada' }
];
